import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.NewOrganisationPopup.ButtonNext', {
    xeroButton: 'Connect to Xero',
    netSuiteButton: 'Connect to Oracle NetSuite',
    nextButton: 'Next',
});
